import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA9FltVsPrbTOCNZa9fBAAG28R57eeQeJw",
  authDomain: "safi-academia.firebaseapp.com",
  projectId: "safi-academia",
  storageBucket: "safi-academia.firebasestorage.app",
  messagingSenderId: "232488354117",
  appId: "1:232488354117:web:9607f70700b891a5edbe2c"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db   = getFirestore(app);
export default app;